import { SxProps, Theme } from '@mui/material'

export const swiperSx: SxProps<Theme> = {
  width: '100%',
}

export const itemsWrapperSx = ({
  dontCenterWhenFewerItems: isLastPageWithFewerItems,
}: {
  dontCenterWhenFewerItems: boolean
}): SxProps<Theme> => {
  return {
    gap: {
      xs: '0.8rem',
      md: '1.6rem',
    },
    justifyContent: {
      xs: 'center',
      md: isLastPageWithFewerItems ? 'start' : 'center',
    },
    margin: 'auto',
    maxWidth: {
      lg: '125.6rem',
      xl: '168rem',
    },
    width: {
      xs: '80%',
      lg: '92%',
    },
  }
}

export const carouselItemSx = ({
  addPadding,
  pointerCursor,
}: {
  pointerCursor: boolean
  addPadding: boolean
}): SxProps<Theme> => {
  return {
    boxSizing: 'border-box',
    minWidth: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    width: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    maxWidth: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    minHeight: {
      xs: '5.3rem',
      md: '7.2rem',
      lg: '8.8rem',
    },
    overflow: 'hidden',
    borderRadius: '0.8rem',
    border: (theme) => `0.1rem solid ${theme.palette.divider}`,
    cursor: pointerCursor ? 'pointer' : 'default',
    padding: addPadding ? '0.8rem !important' : '0 !important',
    background: (theme) => theme.palette.background.paper,
    '&:hover': {
      background: (theme) => theme.palette.background.paper,
    },
  }
}

export const leftArrowWrapperSx: SxProps<Theme> = {
  width: '4rem',
  height: '4rem',
  marginLeft: '-1.2rem',
  '::after': {
    display: 'none',
  },
}

export const rightArrowWrapperSx: SxProps<Theme> = {
  width: '4rem',
  height: '4rem',
  marginRight: '-1.2rem',
  '::after': {
    display: 'none',
  },
}

export const arrowSx = ({ white }: { white: boolean }): SxProps<Theme> => {
  return {
    color: (theme) =>
      white ? theme.palette.primary.contrastText : '#0000008a',
  }
}

export const itemImageSx: SxProps<Theme> = {
  width: '100%',
}
